/**
 * Small persistent indicator that workstation monitoring is running.
 *
 * There is no monitoring screen in the console by design, so this is the only visible trace.
 * It is kept deliberately: monitoring that leaves no sign at all is a materially different
 * product from one that does, it is what the privacy policy validator expects to exist, and it
 * costs one chip of screen space. It states a fact ("Verified workstation") rather than
 * implying a judgement about the person.
 */

import { Chip, Tooltip } from '@mui/material';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';

export function MonitoringIndicator() {
  return (
    <Tooltip
      title={
        'Workstation verification is active. The camera checks that somebody is present and ' +
        'that it is you. Images are processed on this device; no video is stored or uploaded.'
      }
    >
      <Chip
        size="small"
        icon={<VerifiedUserRoundedIcon sx={{ fontSize: '0.95rem' }} />}
        label="Verified workstation"
        variant="outlined"
        sx={{
          height: 24,
          fontSize: '0.68rem',
          fontWeight: 700,
          letterSpacing: '0.02em',
          flexShrink: 0,
          display: { xs: 'none', md: 'inline-flex' },
        }}
      />
    </Tooltip>
  );
}
